import { render, staticRenderFns } from "./WidgetLoader.vue?vue&type=template&id=c6f9c3b2&"
import script from "./WidgetLoader.vue?vue&type=script&lang=js&"
export * from "./WidgetLoader.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports